<template>
 <div>
   <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('gestionAffectation.titleListeAfecctation') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px column is-12 overflow-x-hidden" v-if="this.week">
      <tab-tournee-face-semaine :ref="referenceTable"
                                :referenceTable="referenceTable"
                                :filtres="filtres"
                                :actions="actions"
                                ligneCommandeId=""
                                :afficherDate="true"
                                :disabledDate="false"
                                :afficherBoutonAffecter="false"
                                :afficherBoutonDesaffecter="true"
                                :anneeSemaine="week"
                                :typeDonnee="EXPORT_EXCEL_AFFECTATION_LOGISTIQUE"
                                :afficherToggleCommercialisable="true">
      </tab-tournee-face-semaine>
    </div>
 </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import tabTourneeFaceSemaine from '@/components/logistique/affectation/tabTourneeFaceSemaine';
import * as actionsConf from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import { REFERENCE_TABLE_LISTE_AFFECTATIONS_LOGISTIQUE } from '@/configuration/general/referenceTableConf';

const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');
const Demande = createNamespacedHelpers('demande');
export default {
  name: 'l_affectations',
  components: {
    tabTourneeFaceSemaine,
    breadcrumb,
  },
  data() {
    return {
      actions: [
        { action: actionsConf.ACTION_AFFICHAGE, translation: 'faceDisponible.actions.actionAffichage' },
        { action: actionsConf.ACTION_INSTRUCTION_POSE, translation: 'faceDisponible.actions.instructionPose' },
        { action: actionsConf.ACTION_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.laisserEnPlace' },
        { action: actionsConf.ACTION_ENLEVER_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.enleverLaisserEnPlace' },
        { action: actionsConf.ACTION_AFFECTER_LISTE_AFFICHAGE, translation: 'faceDisponible.actions.affecterListeAffichage' },
      ],
      filtres: {
        estAffecte: true,
        avecNonCommercialisable: false,
      },
      EXPORT_EXCEL_AFFECTATION_LOGISTIQUE: actionsConf.EXPORT_EXCEL_AFFECTATION_LOGISTIQUE,
      referenceTable: REFERENCE_TABLE_LISTE_AFFECTATIONS_LOGISTIQUE,
    };
  },
  computed: {
    ...TourneeFaceSemaine.mapGetters({
      critereRecherche: 'critereRecherche',
    }),
    ...Demande.mapGetters({
      dateSelect: 'dateSelect',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('gestionAffectation.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('gestionAffectation.breadcrumb.listeAffectation'), route: '', isActive: true },
      ];
    },
    week() {
      return Number(getAnneeSemaineFromDate(this.dateSelect));
    },
  },
  mounted() {
    this.critereRecherche.avecLaisserEnPlaceVente = null;
    this.critereRecherche.afficheurIds = [];
    this.critereRecherche.sansAfficheur = null;
    this.setInformationPage(this.$t('pageLogistique.demande.listeAffectation'));
  },
};
</script>

<style scoped>

</style>
